import {Language} from '../../enums/customer_fields/language';
import {CustomerFieldKeys, getValue} from '../../support/get_data';
import {useAppSelector} from '../../store/store';
import {__, transString} from '../../support/lang/translations';
import {SimpleSelect, SimpleSelectOption} from '../select/simple_select.tsx';

interface OwnProps {
    isLoading: boolean;
    isLocked: boolean;
}

export function LanguageSelect(props: OwnProps) {
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);

    const languageData = getValue(meData, CustomerFieldKeys.LANGUAGE);

    const languageOptions: SimpleSelectOption[] = Object.values(Language).map((language) => {
        return {
            label: transString('enums.language.' + language),
            value: language.valueOf(),
        };
    });

    return (
        <label>
            {languageData?.name ?? __('profile.fields.language')}
            <SimpleSelect
                name={languageData?.key ?? CustomerFieldKeys.LANGUAGE}
                defaultValue={languageData?.value || Language.DUTCH}
                options={languageOptions}
                emptyLabel={
                    __('general.select_value', {
                        name: __('profile.fields.select.language') as string,
                    }) as string
                }
                isDisabled={props.isLoading}
                isLocked={props.isLocked}
                useHiddenInput={true}
            />
        </label>
    );
}
